import React from 'react'
import '../6-qualification/qualification.css'

const Qual = () => {
  return (
    <section >
      <div className="container">
        <div className="heading"></div>
        <div className="footing"></div>
      </div>
    </section>
  )
}

export default Qual
